export default {"src":"/_next/static/media/img-upload.6443928e.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};